import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import ProductsSection from "../components/ProductsSection";
import PostMortemSection from "../components/PostMortemSection";
import AwardsSection from "../components/AwardsSection";
import CaseDecksSection from "../components/CaseDecksSection";
import OriginStory from "../components/OriginStory";
import ArtifactsSection from "../components/ArtifactsSection";
import Footer from "../components/Footer";

export default function Portfolio() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("in");
        });
      },
      { threshold: 0.1 }
    );
    document.querySelectorAll(".reveal").forEach((el) => observer.observe(el));
    return () => observer.disconnect();
    // Empty deps intentional: observer is set up once on mount for static landing-page content.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-[#FAF1DC]">
      <Navbar />
      <main>
        <Hero />
        <OriginStory />
        <ProductsSection />
        <PostMortemSection />
        <AwardsSection />
        <CaseDecksSection />
        <ArtifactsSection />
      </main>
      <Footer />
    </div>
  );
}
